import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
const tableColumns = [
    {
        headerLabel: 'Message Type',
        sortKey: 'name',
        cellFunction: (row) => React.createElement(TextCell, null, row.columns.name),
    },
    {
        headerLabel: 'Status',
        sortKey: 'status',
        cellFunction: (row) => React.createElement(TextCell, null, capitalize(row.columns.status)),
    },
];
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    var _a;
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Alert Info', value: props.response.data.alertInfo },
            { label: 'Display Order', value: (_a = props.response.data.displayOrder) !== null && _a !== void 0 ? _a : React.createElement("em", null, "(not set)") },
        ] }));
};
const formConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Message Type',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.text',
            key: 'alertInfo',
            label: 'Alert Info',
        },
        {
            type: 'form.number',
            key: 'displayOrder',
            label: 'Display Order',
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
    ],
};
const editFormConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Message Type',
            disabled: true,
        },
        {
            type: 'form.text',
            key: 'alertInfo',
            disabled: true,
            label: 'Alert Info',
        },
        {
            type: 'form.number',
            key: 'displayOrder',
            label: 'Display Order',
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
    ],
};
export const MessageTypeAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: 'messageType', title: 'Message Type', tableColumns: tableColumns, fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, editFormConfig: editFormConfig }));
};
